import i18n from '@/config/i18n';

import generateFetchUrl from '@/utils/generateFetchUrl';

const cutPropertyParam = (url) => url.replace(/property_id=\d*&/, '');

const { t } = i18n.global;

const prepareCsvBreakdownData = (config) => {
  const data = {
    type: 'breakdown',
    action: 'download',
    name: config.name,
    recipients: config.recipients,
  };

  let browsingUrl;
  let ctpUrl;

  browsingUrl = generateFetchUrl(config.pipe, {
    excludeHost: true,
  });

  browsingUrl = cutPropertyParam(browsingUrl);

  if (config.isCtp) {
    ctpUrl = generateFetchUrl(config.pipe, {
      excludeHost: true,
      isCtpCall: true,
    });

    ctpUrl = cutPropertyParam(ctpUrl);
  }

  const item = {
    metrics: [config.selectedMetric],
    rowKey: 'property_id',
    dataFormat: config.dataFormat,
    columnDescription: config.columnDescription,
    url: browsingUrl,
    ctpUrl,
    name: `${t('Hotels Breakdown')} ${config.dates.startDate}_${config.dates.endDate}`,
  };

  data.items = [item];

  return data;
};

export default prepareCsvBreakdownData;
